// Import styles
import 'bootstrap/scss/bootstrap.scss';
import '../scss/main.scss';

// Import components
import $ from 'jquery';  
window.jQuery = $;
window.$ = $;

// Import plugin
import 'bootstrap/js/src/index'